import { Icon } from '@successmode-ktp/kui';
import React, { useState } from 'react';
import styled from 'styled-components';

type Props = {
  title: string;
  contents: React.ReactNode;
};

export const FaqToggle = ({ title, contents }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <TitleButton
        type='button'
        $isActive={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <div>
          {isOpen ? (
            <Icon.ChevronUp fillColor='#CCCCCC' />
          ) : (
            <Icon.ChevronDown fillColor='#CCCCCC' />
          )}
        </div>
      </TitleButton>
      <TextWrapper $isActive={isOpen}>{contents}</TextWrapper>
    </div>
  );
};

const TitleButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  gap: 8px;
  width: 100%;
  padding: 16px 20px;
  color: ${({ $isActive }) => ($isActive ? '#246CF6' : '#3a3b3e')};
  font-size: 14px;
  font-weight: 600;
`;

const TextWrapper = styled.p<{ $isActive: boolean }>`
  background: var(--KTP-Blue-05, #f4f8ff);
  color: var(--KTP-Grayscale-80, var(--KTP-Color-Mono-80, #3a3b3e));
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.28px;
  padding: ${({ $isActive }) => ($isActive ? '16px 24px' : '0px 24px')};
  height: ${({ $isActive }) => ($isActive ? 'auto' : '0px')};
  transition: all 0.3s;
  overflow: hidden;
`;
